import getCartInventoryDetails from '@tcp/core/src/queries/getInventoryAndCartDetails.query.graphql';
import getCartCachedQuery from '@tcp/core/src/queries/getCartCached.query.graphql';
import getBasketInventoryDetails from '@tcp/core/src/queries/getBasketInventory.query.graphql';
import { executeStatefulGraphQLQuery } from '../../handler';
import { loadStatefulGraphQLInterface } from '../../handler/handler';
import { checkCache } from '../../../utils';

const RES_NULL_ERROR = 'res body is null';
const DefaultTTL = 30;

const writeQuery = (cache, data) => {
  cache.writeQuery({
    query: getCartInventoryDetails,
    data,
  });
};

export const getCartInventoryData = async (skipCache = false, cacheTTL) => {
  return executeStatefulGraphQLQuery({
    query: getCartInventoryDetails,
    type: 'query',
    cacheConfigKey: 'GET_INVENTORY_AND_CART_DETAILS',
    TTL: cacheTTL || DefaultTTL,
    updateQuery: writeQuery,
    fetchPolicy: skipCache ? 'network-only' : '',
  })
    .then((res) => {
      if (!res.data) {
        throw new Error(RES_NULL_ERROR);
      }
      return res.data;
    })
    .catch((err) => {
      throw err;
    });
};

export const getCartDetailsFromCache = () => {
  return loadStatefulGraphQLInterface()
    .then((client) => {
      return client().then((gql) => {
        const isCacheExist = checkCache(gql?.cache, 'getCartCachedQuery');
        if (isCacheExist)
          return gql?.cache?.readQuery({
            query: getCartCachedQuery,
          });
        return null;
      });
    })
    .catch((err) => {
      throw err;
    });
};

export const getInventoryFromCache = () => {
  return loadStatefulGraphQLInterface()
    .then((client) =>
      client().then((gql) => {
        const isCacheExist = checkCache(gql?.cache, 'getBasketInventoryDetails');
        if (isCacheExist)
          return gql?.cache?.readQuery({
            query: getBasketInventoryDetails,
          });
        return null;
      })
    )
    .catch((err) => {
      throw err;
    });
};
